// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1H-jL","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2bhbi"};